export default __webpack_public_path__ + "static/media/service4.506d5025.webp";